/**************************************************************************/
/*** ML Query Builder implemented By Fahad Akbar(fahadakbar24@gmail.com)***/
/**************************************************************************/

angular.module('app.lexstepHeader')
.factory('headerApi', ['api', function(api) {

	var headerApi = {
        updateMeMoveAlert: (payload) =>{ return api.request('POST', `/api/lawyer/update/alert/me-move`, payload); },
    };
    
	return headerApi;
}]);


// WEBPACK FOOTER //
// ./scripts/shared/directives/header/api.js